import { HTMLAttributes, JSX } from "react";
import { FieldErrors, RegisterOptions, UseFormRegister } from "react-hook-form";

import { cn } from "@/utils/cn.ts";

interface TextfieldProps extends HTMLAttributes<HTMLTextAreaElement> {
  color?: "black" | "white";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register?: UseFormRegister<any>;
  name?: string;
  validation?: RegisterOptions;
  placeholder?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: FieldErrors<any>;
  rows?: number;
  className?: string;
}

const Textfield = ({
  color = "black",
  register,
  name,
  validation,
  errors,
  className,
  ...otherProps
}: TextfieldProps): JSX.Element => {
  if (register && !name) throw new Error("You must pass name if you are using register or control");

  return (
    <textarea
      {...otherProps}
      {...(register ? register(name ?? "", validation) : null)}
      className={cn(
        "w-full rounded-[1.25rem] p-5 outline outline-1 -outline-offset-1 outline-grey-1 transition-colors",
        "placeholder:text-on-surface disabled:text-on-surface hover:bg-surface-container-high focus:bg-surface-container-high disabled:outline-surface-bright focus:outline-on-primary disabled:resize-none",
        className,
        {
          "outline-error-1 placeholder:text-error-1 focus:outline-error-1": errors && name && errors[name],
          "bg-surface-bright disabled:bg-surface-bright": color === "black",
          "bg-surface-container disabled:bg-surface-container": color === "white",
        },
      )}
    />
  );
};

export default Textfield;
